import React from 'react';
import SpinnerBlock from '../../../common/SpinnerBlock';
import ItemList from '../ItemList';
import SupplierBlock from '../SupplierBlock';
import ConsignorBlock from '../ConsignorBlock';
import WarehouseBlock from '../WarehouseBlock';
import OtherBlock from '../OtherBlock';
import styled from '@emotion/styled';
import MobileHeeader from '../../Header/MobileHeader';
import MobileHistoryBlock from '../HistoryBlock/MobileHistoryBlock';
import DesktopHeader from '../../Header/DesktopHeader';
import AcceptanceSettingsBlock from '../AcceptanceSettingsBlock';

const Wrapper = styled('div')`
  margin: 0 -22px;

  .card-box {
    min-height: 200px;
    border-radius: 0;
    border-left: none;
    border-right: none;
    margin-bottom: 20px;
    padding: 16px 0;
    box-shadow: none;

    &.disabled,
    &.add-info {
      display: flex;
      flex-direction: column;
    }

    &.card-box-main {
      position: static;
      padding-bottom: 0;
    }

    > div {
      padding-left: 15px;
      padding-right: 15px;
      padding-bottom: 10px;
    }

    .react-datepicker-wrapper {
      display: block;
    }

    p {
      padding-left: 15px;
      padding-right: 15px;
    }

    .card-title {
      margin: 0;
      padding: 0 16px 9px;
    }

    .header-title {
      font-size: 14px;
      margin: 0;
    }

    .payment-flex {
      padding: 0 16px;

      .payment-flex-block {
        padding-top: 16px;
      }

      .border-top {
        margin-left: -16px;
        margin-right: -16px;
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    .border-top {
      padding-left: 16px;
      padding-right: 16px;
    }

    .card-content {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
  .block-subtitle {
    color: #98a6ad;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .change-link {
    color: #7e57c2;
    cursor: pointer;
  }
  .border-top {
    border-top: 1px solid #ccc;
    padding-top: 15px;
  }
  .blocked-block {
    border-top: 1px solid #ccc;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ccc;
  }

  div.tags-wrapper {
    padding: 0 16px;

    .tag {
      padding: 0 16px;
    }
  }

  .status-badge,
  .payment-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-left: 10px;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background: #ccc;
    border: 1px solid #fff;
    color: #296775;
    padding: 2px 8px 0;
    min-width: 80px;
    text-align: center;
    height: 19px;

    i {
      font-size: 12px;
      margin-top: -2px;
    }
  }

  .packing {
    .packings-wrapper {
      padding: 10px 15px;
      position: relative;
    }

    .parameters {
      margin: 10px 0 0 !important;

      span {
        display: block;
        margin: 0 !important;
      }
    }

    .show-packing-info-button {
      position: absolute;
      top: 20px;
      right: 30px;
      left: unset;
      bottom: unset;
      color: #72747b;
      font-size: 12px;
      font-weight: 600;
    }
  }
`;

const MobileLayout = (props) => {
  const {
    isNew,
    getCurrentSupply,
    currentSupply,
    currentWarehouse,
    saveSupply,
    setQuantityFactChange,
    supplyHistory,
    handleWarehouseChange,
    isSupplyClosed,
    otherBlockRef,
    supplyCustomId,
    setSupplyCustomId,
  } = props;

  return (
    <>
      <MobileHeeader supplyCustomId={supplyCustomId} setSupplyCustomId={setSupplyCustomId} />
      <Wrapper>
        {/* <SpinnerBlock show={getCurrentSupply.isFetching} /> */}
        {currentSupply ? (
          <>
            <ItemList
              currentWarehouse={currentWarehouse}
              handleSaveSupply={saveSupply}
              setQuantityFactChange={setQuantityFactChange}
            />
            <SupplierBlock />
            <WarehouseBlock
              currentWarehouse={currentWarehouse}
              handleChange={handleWarehouseChange}
              isSupplyClosed={isSupplyClosed}
              currentSupply={currentSupply}
            />
            <OtherBlock isNew={isNew} ref={otherBlockRef} />
            <ConsignorBlock />
            <AcceptanceSettingsBlock />
          </>
        ) : null}
        {supplyHistory && supplyHistory.length ? (
          <MobileHistoryBlock supplyHistory={supplyHistory} />
        ) : null}
      </Wrapper>
    </>
  );
};

export default MobileLayout;
